import { Button, Flex, useToast } from '@chakra-ui/react';
import useToastError from 'hooks/shared/useToastError';
import FullScreenLoader from 'presentation/components/shared/FullScreenLoader';
import AlertModal from 'presentation/components/shared/modals/AlertModal';
import {
  ButtonSize,
  ButtonVariant,
} from 'presentation/theme/components/button';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useRequestNotificationMutation } from 'rtkQuery/sharespro/queries/notifications';

interface Props {
  text: string;
  title: string;
  isOpen: boolean;
  onClose: () => void;
  notificationId: string;
}

const RequestNotificationModal: FC<Props> = ({
  text,
  title,
  isOpen,
  onClose,
  notificationId,
}) => {
  const { t } = useTranslation();

  const toast = useToast();

  const toastErrorHandler = useToastError();

  const [requestNotification, { isLoading }] = useRequestNotificationMutation();

  return (
    <>
      <AlertModal
        isOpen={isOpen}
        onClose={onClose}
        text={text}
        title={title}
        footer={
          <Flex>
            <Button
              variant={ButtonVariant.Ghost}
              mr={3}
              size={ButtonSize.sm}
              onClick={onClose}
            >
              {t('requestCallManagerDecline')}
            </Button>
            <Button
              size={ButtonSize.sm}
              onClick={() => {
                requestNotification({ id: notificationId })
                  .unwrap()
                  .then(() => {
                    toast({
                      description: t('requestCallManagerSuccess'),
                      status: 'success',
                      position: 'top-right',
                      duration: 10000,
                      isClosable: true,
                    });
                    onClose();
                  })
                  .catch((err) => toastErrorHandler(err));
              }}
            >
              {t('requestCallManagerAccept')}
            </Button>
          </Flex>
        }
      />
      <FullScreenLoader isLoading={isLoading} />
    </>
  );
};

export default RequestNotificationModal;
